import { createFileRoute, Link } from '@tanstack/react-router';
import { LearnMore } from '../components/guidance/learn-more';
import { PageHeader } from '../components/layout/app-shell';

export const Route = createFileRoute('/admin/')({ component: AdminHome });

const SECTIONS = [
  { to: '/admin/users', label: 'Users & access', text: 'approve requests, roles, suspend, reset authenticators.' },
  { to: '/admin/ai', label: 'AI routing', text: 'which models do each task, Compare, fallbacks, monthly budgets and spend.' },
  {
    to: '/admin/quality',
    label: 'AI quality',
    text: 'how the routes compare per task: agreement, adoptions, corrections, time and cost.',
  },
  { to: '/admin/schema', label: 'Schema', text: 'entity types, colors, ID prefixes and the fields of every profile.' },
  { to: '/admin/templates', label: 'Profile templates', text: 'the Actor Profile Sheet v2.0 blocks, variants and versions.' },
  { to: '/admin/lists', label: 'Value lists', text: 'Camp, Status, Investigation status, rating scale and dimensions.' },
  { to: '/admin/relations', label: 'Relation types', text: 'links between actors, participation and vote roles, money flows.' },
  {
    to: '/admin/colors',
    label: 'Color rules',
    text: 'what “Color by: Rules” shows: ordered rules, first match wins, with a live preview.',
  },
  {
    to: '/admin/search',
    label: 'Search index',
    text: 'how much of the Library and the names is searchable by words and by meaning; rebuild.',
  },
  {
    to: '/admin/matching',
    label: 'Matching',
    text: 'the certainty a match needs before it is applied without a person; everything below goes to review.',
  },
  {
    to: '/admin/report-gates',
    label: 'Report quality gates',
    text: 'the eight checks a full report runs before an export: proof wording, cross-references, numbers, case limits, named persons, base rates, the author’s reading, summary points; each advisory or blocking.',
  },
  {
    to: '/admin/audit',
    label: 'Audit log',
    text: 'who viewed, changed, exported or signed in, and when; filter by person, action, record and day.',
  },
  { to: '/admin/backups', label: 'Backups', text: 'Time Travel, the nightly and pre-update exports, and the monthly audit archive.' },
  {
    to: '/admin/api-keys',
    label: 'API keys',
    text: 'keys that let other programs send files in, each with its sensitivity and daily quotas; revoke.',
  },
  {
    to: '/admin/scrapers',
    label: 'Website monitors',
    text: 'web pages checked on a schedule; changed pages are stored and processed like uploads; switch all off.',
  },
  {
    to: '/admin/registers',
    label: 'Public registers',
    text: 'European Parliament votes, declared meetings, written questions and posts fetched as claims with the register as source; matches to check.',
  },
  {
    to: '/admin/social',
    label: 'Social feeds',
    text: 'accounts followed on social media platforms and the API credentials each platform needs; feeds stay off until their connector is ready.',
  },
  {
    to: '/admin/sources',
    label: 'Sources',
    text: 'what the Upload page, API keys, website monitors and social feeds brought in, and what was already here (duplicates).',
  },
  {
    to: '/admin/outlets',
    label: 'Outlets',
    text: 'the source registry: who owns each outlet, its type, and which sources count as one when facts are corroborated.',
  },
  {
    to: '/admin/monitoring',
    label: 'Monitoring',
    text: 'system checks every 5 minutes, incidents, stuck processing jobs, AI budget alerts and the daily digest.',
  },
  {
    to: '/admin/help',
    label: 'Help articles',
    text: 'your own Onboarding articles (methodology, standards) and what readers are missing.',
  },
] as const;

function AdminHome() {
  return (
    <>
      <PageHeader title="Admin" description="Users, schema, AI routing, budgets and the audit log." />
      <ul className="space-y-2 text-sm">
        {SECTIONS.map(s => (
          <li key={s.to}>
            <Link to={s.to} className="font-medium underline">
              {s.label}
            </Link>{' '}
            <span className="text-muted-foreground">— {s.text}</span>
          </li>
        ))}
      </ul>
      <div className="mt-4">
        <LearnMore slug="admin-overview" />
      </div>
    </>
  );
}
